import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectVideo12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectVideo12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 2h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M0 2.5A1.5 1.5 0 0 1 1.5 1h4A1.5 1.5 0 0 1 7 2.5v7A1.5 1.5 0 0 1 5.5 11h-4A1.5 1.5 0 0 1 0 9.5zM9 3a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 0-1zm-.5 2.5A.5.5 0 0 1 9 5h1.5a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5M2.975 8.26l2.24-1.791a.6.6 0 0 0 0-.938L2.975 3.74A.6.6 0 0 0 2 4.208v3.584a.6.6 0 0 0 .975.468M3 5.04 4.2 6 3 6.96z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectVideo12);
